import React, { useRef, useEffect } from 'react'

import styled from 'styled-components'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'

import avatar from '../../../assets/images/avatar-temp.png'

import P from '../../../components/typography/P'

import { setCvImageFile } from '../../../redux/feature/applicantSlice'

const CVImageUpload = ({ onChangeImage, imageLink }) => {
  const dispatch = useDispatch()
  const fileInputRef = useRef(null)
  const imageRef = useRef(null)

  const handleAvatarClick = () => {
    fileInputRef.current?.click()
  }

  const handleImageChange = (event) => {
    const file = event.target.files[0]
    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      toast.error('Please upload a valid image')
    } else if (file.size > 2000000) {
      toast.error('Image too big (max 3MB)')
    } else {
      if (fileInputRef?.current?.files[0]) {
        const fileReader = new FileReader()
        fileReader.onload = function (event) {
          const link = event.target.result
          imageRef.current.src = link
          onChangeImage(link)
        }
        fileReader.readAsDataURL(fileInputRef.current.files[0])
        dispatch(setCvImageFile(file))
      }
    }
  }

  useEffect(() => {
    if (imageLink) {
      imageRef.current.src = imageLink
    } else {
      imageRef.current.src = avatar
    }
  }, [imageLink])

  return (
    <Container>
      <Avatar onClick={handleAvatarClick}>
        <Image ref={imageRef} alt="Uploaded CV" />
        <FileUploadInput
          ref={fileInputRef}
          type="file"
          accept="image/*"
          alt="Upload CV Photo"
          onChange={handleImageChange}
        />
      </Avatar>
      <P>Click to upload CV image</P>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`

const FileUploadInput = styled.input`
  display: none;
`

const Image = styled.img`
  width: 9.375rem;
  height: 8.125rem;
  border-radius: 50%;
  object-fit: cover;
`

const Avatar = styled.div`
  width: 9.375rem;
  height: 8.125rem;
  display: flex;
  border-radius: 50%;
  background-color: rgb(229, 229, 229);
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgb(200, 200, 200);
    cursor: pointer;
  }

  svg {
    opacity: 0.5; /* Dimmed by default */
    filter: brightness(0.9);
    transition: opacity 0.2s, transform 0.2s, filter 0.2s;
    width: 3.75rem;
    height: 3.75rem;
  }

  &:hover svg {
    opacity: 1; /* Fully visible on hover */
    transform: scale(1.12);
    filter: brightness(0.85);
  }
`

export default CVImageUpload
